module.exports = __webpack_public_path__ + "img/page-top-img.558a1adf.svg";